export default {"src":"/_next/static/media/xpa.a87c3e1c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};